export interface PurchaserProps {
  purchaserId: number;
  purchaserKey: string;
  purchaserName: string;
}

export class Purchaser {
  private readonly _purchaserId: number;
  private readonly _purchaserKey: string;
  private readonly _purchaserName: string;

  constructor(props: PurchaserProps) {
    this._purchaserId = props.purchaserId;
    this._purchaserKey = props.purchaserKey;
    this._purchaserName = props.purchaserName;
  }

  public get purchaserId(): number {
    return this._purchaserId;
  }

  public get purchaserKey(): string {
    return this._purchaserKey;
  }

  public get purchaserName(): string {
    return this._purchaserName;
  }

  public static fromJson(json: PurchaserProps): Purchaser {
    return new Purchaser(json);
  }
}
